import * as React from 'react';
import classNames from 'classnames';

import styles from './Collapsible.module.scss';

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  open: boolean;
  children: React.ReactNode;
}

const Collapsible: React.FunctionComponent<Props> = ({
  className,
  style,
  open,
  children,
}) => {
  const [height, setHeight] = React.useState(0);
  const contentRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!height || !open || !contentRef.current) {
      return undefined;
    }

    // Observe height changes
    const resizeObserver = new ResizeObserver(() => {
      setHeight(contentRef.current?.scrollHeight || 0);
    });
    resizeObserver.observe(contentRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [height, open]);

  React.useEffect(() => {
    setHeight(open ? contentRef.current?.scrollHeight || 0 : 0);
  }, [open]);

  return (
    <div
      className={classNames(styles.container, className)}
      aria-hidden={!open}
      style={{ ...style, height }}
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
};

export default Collapsible;
